<template>
  <div class="card">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
          <path d="M18 17V9"></path>
          <path d="M13 17V5"></path>
          <path d="M8 17v-3"></path>
        </svg>
        量表详细分数
      </div>
    </div>
    <div class="p-6 pt-0">
      <div class="space-y-4">
        <div 
          v-for="dimension in dimensionResults"
          :key="dimension.id"
          class="flex items-center justify-between p-4 bg-gray-50 rounded-lg"
        >
          <div class="flex-1">
            <h4 class="font-medium">{{ dimension.name }}</h4>
            <p class="text-sm text-gray-600">{{ dimension.description }}</p>
          </div>
          <div class="text-right ml-4">
            <div class="text-xl font-bold text-psychology-primary">{{ dimension.rawScore }}</div>
            <div class="text-xs text-gray-500 mt-1">Z分数: {{ dimension.zScore.toFixed(2) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailedScores',
  props: {
    dimensionResults: {
      type: Array,
      required: true
    }
  }
}
</script>

